let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jEgnx")).then(() => parcelRequire('k5AOl'));